import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';


export const authGuard = (): boolean => {
  const auth = inject(AuthService);
  if (!auth.token) {
    void inject(Router).navigate(['/auth/login']);
    return false;
  }
  // Super-admin met zijn eigen inlog: die heeft geen club, dus eerst kiezen
  // (clubkiezer, 24-10-2026). Zonder club gaven de schermen fouten.
  if (auth.isBeheerderZonderClub) {
    void inject(Router).navigate(['/auth/kies-club']);
    return false;
  }
  return true;
}
